















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ContentCard extends Vue {
  @Prop()
  videoOnly!: boolean;

  get bodyClass() {
    if (this.videoOnly) {
      return "text-left p-0";
    }
    return "text-left pl-0";
  }
}
